import { Character } from 'models/Character';
import { LadderInformationGame } from 'components/LadderInformationGame.jsx';
import { CacheableDataObject } from '../models/CacheableDataObject';
import { GameRoom } from '../models/GameRoom';

class LadderInformation extends CacheableDataObject {

	beforeConstruct() {
		this.games = new Map();
	}

	extend(games) {
		this.update({ games: games });
	}

	get user() {
		console.error('change this to use .player');
		return this.player; // Just in case
	}

	getLeagueForMatch(match) {
		let league = null;
		if(match.isRanked()) {
			league = this.getLeagueForLadder(match.ladder.id);
		}
		else {
			league = this.getHighestLeagueForLadder(match.ladder.id);
		}
		return league;
	}

	getHighestLeagueForLadder(ladderId) {
		ladderId = parseInt(ladderId);
		let foundLeague = null;
		if(this.games.get(ladderId) && this.games.get(ladderId).highest_league) {
			foundLeague = this.games.get(ladderId).highest_league || null;
			return foundLeague;
		}
		return null;
	}

	getLeagueForLadder(ladderId) {
		ladderId = parseInt(ladderId);
		let foundLeague = null;
		if(this.games.get(ladderId) && this.games.get(ladderId).league) {
			foundLeague = this.games.get(ladderId).league || null;
			return foundLeague;
		}
		return null;
	}

	getSelectedSlotForLadder(ladderId) {
		ladderId = parseInt(ladderId);
		if(this.games.get(ladderId) && this.games.get(ladderId).selected_slot) {
			return this.games.get(ladderId).selected_slot;
		}
		return 1;
	}

	setSelectedSlotForLadder(ladderId, slot) {
		ladderId = parseInt(ladderId);
		if(this.games.get(ladderId)) {
			return this.games.get(ladderId).selected_slot = slot;
		}
		else {
		}
	}

	addMainForLadder(ladderId, character) {
		if(this.games.get(ladderId) && this.games.get(ladderId).mains) {
			character = Character.retrieve(character);
			if(!character.id) {
				return;
			}
			this.games.get(ladderId).mains.set(character.id, character);
		}
	}

	removeMainForLadder(ladderId, character) {
		if(this.games.get(ladderId) && this.games.get(ladderId).mains) {
			character = Character.retrieve(character);
			if(!character.id) {
				return;
			}
			this.games.get(ladderId).mains.delete(character.id);
		}
	}

	getLadderInfo(ladderId) {
		ladderId = GameRoom.verifyLadderId(ladderId);
		if(this.games.get(ladderId)) {
			return this.games.get(ladderId);
		}
		return null;
	}

	getMainsForLadder(ladderId, limit = 3) {
		const ladderInfo = this.getLadderInfo(ladderId);
		if(!ladderInfo) {
			return [];
		}
		return ladderInfo.getMains(limit);
	}

	getMainsForLadderAsMap(ladderId) {
		const ladderInfo = this.getLadderInfo(ladderId);
		if(!ladderInfo) {
			return new Map();
		}
		return ladderInfo.getMainsAsMap();
	}

	getMainsByType(type = 'profile', ladderId) {
		switch(type) {
			case 'profile': {
				return this.getMainsForLadder(ladderId);
			}
			case 'ranked': {
				return this.getCharactersForLadder(ladderId);
			}
			default:
				throw new Error('invalid type provided');
		}
	}

	getLaddersByGameId(gameId) {
		let list = [];
		for(let [i, ladder] of this.games) {
			if(ladder.game_id == gameId) {
				list.push(ladder);
			}
		}
		return list;
	}

	getCharactersForLadder(ladderId) {
		ladderId = parseInt(ladderId);
		if(this.games.get(ladderId) && this.games.get(ladderId).characters) {
			return this.games.get(ladderId).characters;
		}
		return [];
	}

	hasCharactersForLadder(ladderId) {
		return this.getCharactersForLadder(ladderId).length !== 0;
	}

	getLadder(id) {
		return this.games.get(parseInt(id));
	}

	hasLadders() {
		return !!this.games.size;
	}

	getLadders() {
		return this.games;
	}

	getLaddersInOrder() {
		this.games = new Map([...this.getLadders().entries()].sort((ladderA, ladderB) => {
				if(ladderA[1].order === ladderB[1].order) {
					return 0;
				}
				return ladderA[1].order > ladderB[1].order ? 1 : -1;
			})
		);
		return this.games;
	}

	getPreferredLadderInformationGamesInOrder() {
		return Array.from(this.getLaddersInOrder())
			.map(([_, ladderInformationGame]) => (ladderInformationGame))
			.filter((ladderInformationGame) => {
				if(!this.player.preferred_games.size) {
					return false;
				}
				return !!this.player.preferred_games.retrieve(ladderInformationGame.id);
			});
	}

}

LadderInformation.prototype.dataLocationParsers = {
	games: function(object, data) {
		if(!object.games) {
			object.games = new Map();
		}
		_.each(data.games, (game, index) => {
			index = Number.parseInt(index, 10);
			if(!index) {
				return;
			}
			if(object.games.get(index, game)) {
				object.games.get(index).update(game);
			}
			else {
				object.games.set(index, LadderInformationGame.create(game));
			}
		});
	}
};
export { LadderInformation };